// @ts-strict

import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss']
})
export class SecondaryButtonComponent {
  @Input() maxWidth?: number;
  @Input() height?: number;
  @Input() className?: string;
  @Input() text?: string;
  @Input() secondIcon?: string;
  @Input() icon?: string;
  @Input() backgroundColor?: string;
  @Input() largeButton?: boolean;
  @Input() iconSize?: number;
  @Input() secondIconSize?: number;
  @Input() alertButton?: boolean;
  @Input() confirmationButton?: boolean;
  @Input() selected?: boolean;
  @Input() font500?: boolean;
  @Input() iconWeight?: number;
  @Input() isLoading = false;
  @Input() disabled = false;

  @Output() emitAction = new EventEmitter<MouseEvent>();

  public get isGreyBackground(): boolean {
    return this.backgroundColor === 'grey';
  }
  public get isWhiteBackground(): boolean {
    return this.backgroundColor === 'white';
  }
  public get isGreenBackground(): boolean {
    return this.backgroundColor === 'green';
  }
  public get isPrimaryBackground(): boolean {
    return this.backgroundColor === 'primary';
  }
  public get isAmberBackground(): boolean {
    return this.backgroundColor === 'amber';
  }
  public get isDangerBackground(): boolean {
    return this.backgroundColor === 'danger';
  }
  public get isWhiteBackgroundWithBorder(): boolean {
    return this.backgroundColor === 'white-with-border';
  }
  public get isCleanWhite(): boolean {
    return this.backgroundColor === 'clean-white';
  }
  public get isDiscordBackground(): boolean {
    return this.backgroundColor === 'discord';
  }

  public get isRedBanner(): boolean {
    return this.backgroundColor === 'red-banner';
  }
  public get isYellowBanner(): boolean {
    return this.backgroundColor === 'yellow-banner';
  }
  public get isGreenBanner(): boolean {
    return this.backgroundColor === 'green-banner';
  }
  public get isLavenderBanner(): boolean {
    return this.backgroundColor === 'lavender-banner';
  }
  public get isBlueBanner(): boolean {
    return this.backgroundColor === 'blue-banner';
  }
  public get isDarkBlueBanner(): boolean {
    return this.backgroundColor === 'dark-blue-banner';
  }

  public handleClick(ev: MouseEvent): void {
    this.emitAction.emit(ev);
  }
}
